import React from 'react'
import Svg from './Svg'
export const SvgLock = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M19.63 9.829V7.657a7.658 7.658 0 00-15.315 0V9.83c-1.028.228-1.828 1.028-1.828 2.171v9.829A2.17 2.17 0 004.658 24h14.4a2.17 2.17 0 002.171-2.171V12c.23-1.029-.57-1.943-1.6-2.171zm-3.2 0h-8.8V7.657a4.34 4.34 0 014.342-4.343 4.34 4.34 0 014.343 4.343V9.83z" />
  </Svg>
))
SvgLock.isIcon = true
export default SvgLock
